"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/segments/MobileCameraSetup.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _videoCall = require('web/selectors/videoCall');
var _hooks = require('web/services/hooks');
var _Camera = require('web/components/VideoCall/Setup/MobileSetup/Camera'); var _Camera2 = _interopRequireDefault(_Camera);
var _useSetupStream = require('./useSetupStream');









// Was a class inside connect(): memo keeps connect's props bail-out.
const CameraSetupContainer = ({
  onCycleCam,
  isCamCycleAvailable,
  areCamIssuesPresent,
  gotoNextStep,
  onUserProblemPublish,
}) => {
  const currentCamDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId)

  const stream = _useSetupStream.useSetupStream.call(void 0, 'cam', currentCamDeviceId, onUserProblemPublish)

  return (
    _react2.default.createElement(_Camera2.default, {
      videoStream: stream,
      onCycleCam: onCycleCam,
      isCamCycleAvailable: isCamCycleAvailable,
      areCamIssuesPresent: areCamIssuesPresent,
      gotoNextStep: gotoNextStep, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
    )
  )
}

exports. default = _react.memo.call(void 0, CameraSetupContainer)
